import React from 'react'
import Navbar from '../Navbar'
import { Link, NavLink } from "react-router-dom";
import Lottie from "lottie-react";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
    AccordionItemState,
} from 'react-accessible-accordion';
import Footer from '../Footer';
import BannerBg from "../../img/conversionBG.avif";
import WhyBg from "../../img/vitualCardBG.png";
import { FiMinus } from "react-icons/fi";
import { FiPlus } from "react-icons/fi";
import DownloadAfriPay from "../DownloadAfriPay";
import animationData from "../../animations/virtualCardAnimation.json";
import { SEO } from '../SEO';
import { FaAngleDown, FaAngleUp, FaRegArrowAltCircleRight, FaStar } from 'react-icons/fa';
import { LuSmartphone } from "react-icons/lu";
import { FaCheck } from "react-icons/fa6";
import { MdOutlineSchool } from "react-icons/md";
import { FaTv } from "react-icons/fa";
import { motion } from "framer-motion";
import HeroCTA1 from '../HeroCTA1';
import HeroCTA2 from '../HeroCTA2';
import { useDownloadAppModal } from '../../context/DownloadAppModalContext';

const slideInLeft = {
    hidden: { opacity: 0, x: -80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

const slideInRight = {
    hidden: { opacity: 0, x: 80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

const container = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const fadeUp = {
    hidden: {
        opacity: 0,
        y: 40,
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut",
        },
    },
};

const fadeUpImage = {
    hidden: { opacity: 0, y: 40, scale: 0.96 },
    visible: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: { duration: 0.7, ease: "easeOut" },
    },
};

function BillsPaymentV3() {
    const { openDownloadModal } = useDownloadAppModal();

    return (
        <>

            <SEO
                title="Virtual Card | Afripay"
                description="Get Virtual cards to shop globally on Afripay."
                canonical="https://goafripay.com/virtual-card-page"
            />

            <Navbar />



            {/* Hero Section */}
            <section className='bg-white max-w-7xl mx-auto md:pt-[120px] pb-10'>
                <motion.div
                    style={{
                        backgroundImage: `url(${BannerBg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                    }}
                    variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}
                    className='flex flex-col lg:flex-row items-center text-center lg:text-left lg:items-start justify-between rounded-3xl py-24 lg:py-12 px-10 gap-4 lg:gap-0'
                >
                    <motion.div variants={slideInLeft} className='max-w-[250px] md:max-w-[512px] mb-3 lg:mb-0'>
                        <h1 className='text-white text-2xl md:text-[56px] font-display-fran font-bold mb-4 lg:mb-6 md:leading-[60px]'>Payment at Scale made simple!</h1>
                        <p className='text-white text-base md:text-lg'>Pay all your bills in one place. Electricity, water, internet, TV subscriptions, and more.</p>
                    </motion.div>
                    <motion.div variants={slideInRight}>
                        <img src="/images/bill_payment_hero.avif" alt="Bill Payment" width={520} className='hidden md:block' />
                        <img src="/images/bill_payment_hero_mobile.avif" alt="Bill Payment" className='w-full block md:hidden' />
                        <div className='w-full flex justify-between items-center gap-3.5'>
                            <button className="w-full h-13 p-3.5 text-sm text-white border border-[#E9E9E9] rounded-xl" onClick={openDownloadModal}>See all Billers</button>
                            <button className="w-full h-13 p-3.5 text-sm text-white bg-[#0B7F47] border-2 border-[#7FBC51] rounded-xl" onClick={openDownloadModal}>Pay Bill Now</button>
                        </div>
                    </motion.div>
                </motion.div>
            </section>

            {/* One Account, Global Power */}
            <div className="bg-[#FFFCEA] py-16 px-9 text-center">
                <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='max-w-7xl mx-auto flex flex-col items-center'>
                    <motion.h2 variants={fadeUp} className='text-3xl text-[#030319] font-display-fran font-bold'>What you can pay for</motion.h2>
                    <motion.p variants={fadeUp} className='text-lg text-[#344054] mb-11'>All your bills, one platform</motion.p>
                    <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 justify-items-center gap-4'>
                        {[
                            { icon: "⚡", title: "Electricity", text: "PHCN, KEDCO, IKEDC, EKEDC", link: "/bills-payment" },
                            { icon: "📖", title: "Student Services", text: "Course materials and projects", link: "/students" },
                            { icon: "🏥", title: "Insurance", text: "Health, Auto, Life", link: "/health-travel-insurance" },
                            { icon: "📺", title: "Cable TV", text: "DSTV, GOTV, StarTimes", link: "/bills-payment" },
                            { icon: "💳", title: "Pay with Rewards", text: "Pay with Afripay Coins", link: "/afripay-coin-page" },
                            { icon: "🏫", title: "School Fees", text: "Universities, Schools", link: "/tuition-payment" },
                            { icon: "🛫", title: "Flight Booking", text: "Anywhere in the world", link: "/book-flight" },
                            { icon: "🌐", title: "Developer API", text: "All major payment providers", link: "/freelancers" },
                            { icon: "🏦", title: "Study Loans", text: "Pay for tuition with Afirpay study loans", link: "/student-loan" },
                        ].map((item, i) => (
                            <motion.a
                                href={item.link}
                                key={i}
                                variants={fadeUpImage}
                                className='w-[212px] h-[155px] p-6 rounded-xl bg-[#FFF/10] shadow-md transition-all duration-300 cursor-pointer hover:bg-[#D5EAC9]'
                            >
                                <span className='text-4xl mb-3'>{item.icon}</span>
                                <h1 className='text-[#101828] font-semibold text-lg mb-2'>{item.title}</h1>
                                <p className='text-[#4A5565] text-sm font-normal'>{item.text}</p>
                            </motion.a>
                        ))}
                    </div>
                </motion.div>
            </div>

            <section className='bg-white max-w-7xl mx-auto py-16 px-9 flex flex-col items-center text-center gap-20'>
                <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='w-full flex flex-col lg:flex-row items-center justify-between gap-11'>
                    <motion.div variants={slideInLeft} className='flex flex-col items-center lg:items-start gap-11 max-w-[650px]'>
                        <div className='text-left flex flex-col items-center lg:items-start gap-3'>
                            <span className='bg-[#EFEFEF33] border border-[#F4F4F5] rounded-3xl text-[#101828] text-sm flex items-center justify-center gap-1'><LuSmartphone /> Airtime & Data</span>
                            <h1 className='text-[#030319] text-xl md:text-3xl font-bold font-display-fran'>Recharge your phone easily on the AfriPay</h1>
                            <p className='text-[#344054] text-sm md:text-base'>Buy airtime for yourself and others, purchase data bundles for all networks, and enjoy seamless connectivity at the best rates.</p>
                        </div>
                        <div>
                            <div className='flex items-center gap-3 text-[#364153] text-xs md:text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Instant airtime recharge for all networks</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Buy data bundles at competitive rates</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Set up auto-renewal for convenience</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Share data with friends and family</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Get bonus data on bulk purchases</p>
                            </div>
                        </div>
                        <button onClick={openDownloadModal} className='p-3.5 border-2 border-[#7FBC51] bg-[#0B7F47] rounded-xl text-sm text-white'>Buy Airtime</button>
                    </motion.div>
                    <motion.div variants={slideInRight}>
                        <img src="/images/airtime.avif" alt="Instant Card Creation" className='max-w-[250px] md:max-w-[433px]' />
                    </motion.div>
                </motion.div>
                <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='w-full flex flex-col lg:flex-row-reverse items-center justify-between gap-11'>
                    <motion.div variants={slideInLeft} className='flex flex-col items-center lg:items-start gap-11 max-w-[650px]'>
                        <div className='text-left flex flex-col items-center lg:items-start gap-3'>
                            <span className='bg-[#EFEFEF33] border border-[#F4F4F5] rounded-3xl text-[#101828] text-sm flex items-center justify-center gap-1'><MdOutlineSchool /> Exam Vouchers</span>
                            <h1 className='text-[#030319] text-xl md:text-3xl font-bold font-display-fran'>Purchase WAEC, NECO, and JAMB exam vouchers instantly with AfriPay. </h1>
                            <p className='text-[#344054] text-sm md:text-base'>Buy exam vouchers for yourself and others, get immediate e-pin delivery via SMS or email.</p>
                        </div>
                        <div>
                            <div className='flex items-center gap-3 text-[#364153] text-xs md:text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Instant e-pin delivery via sms or email</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Multiple Payment Options</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Price Transparency</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Confirmation and Verification</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Bulk purchase options</p>
                            </div>
                        </div>
                        <button onClick={openDownloadModal} className='p-3.5 border-2 border-[#7FBC51] bg-[#0B7F47] rounded-xl text-sm text-white'>Buy Exam Voucher</button>
                    </motion.div>
                    <motion.div variants={slideInRight}>
                        <img src="/images/exam.avif" alt="Exam" className='max-w-[250px] lg:max-w-[433px]' />
                    </motion.div>
                </motion.div>
                <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='w-full flex flex-col lg:flex-row items-center justify-between gap-11'>
                    <motion.div variants={slideInLeft} className='flex flex-col items-center lg:items-start gap-11 max-w-[650px]'>
                        <div className='text-left flex flex-col items-center lg:items-start gap-3'>
                            <span className='bg-[#EFEFEF33] border border-[#F4F4F5] rounded-3xl text-[#101828] text-sm flex items-center justify-center gap-1'><FaTv /> TV Subscription</span>
                            <h1 className='text-[#030319] text-xl md:text-3xl font-bold font-display-fran'>Pay your TV subscriptions  easily on AfriPay!</h1>
                            <p className='text-[#344054] text-sm md:text-base'>Easily renew your DStv, GOtv, or Startimes subscriptions right from your AfriPay app fast, secure, and convenient.</p>
                        </div>
                        <div>
                            <div className='flex items-center gap-3 text-[#364153] text-xs md:text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Instant subscription activation</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Support for all major TV providers</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Auto-renewal options available</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Multiple payment methods accepted</p>
                            </div>
                            <div className='flex items-center gap-3 text-[#364153] text-sm'>
                                <span className='w-6 h-6 rounded-full bg-[#F6FDF4] flex items-center justify-center'><FaCheck color='#0B7F47' /></span>
                                <p>Manage all subscriptions in one place</p>
                            </div>
                        </div>
                        <button onClick={openDownloadModal} className='p-3.5 border-2 border-[#7FBC51] bg-[#0B7F47] rounded-xl text-sm text-white'>Buy Airtime</button>
                    </motion.div>
                    <motion.div variants={slideInRight}>
                        <img src="/images/cable_tv.avif" alt="Cable TV" className='max-w-[200px] lg:max-w-[495px]' />
                    </motion.div>
                </motion.div>
            </section>

            <section className='bg-[#D5EAC9] py-20 px-9'>
                <div className='max-w-7xl mx-auto flex flex-col items-center gap-8'>
                    <div className='flex flex-col items-center text-center gap-3'>
                        <img src="/images/health_and_travel.png" alt="Health and Travel" />
                        <h2 className='text-[#030319] text-3xl font-bold font-display-fran'>Travel with Ease Using AfriPay Insurance</h2>
                        <p className='text-xl text-[#344054]'>Find affordable insurance deals for you! Your visa, health, and travel assurance on every trip. Powered by SwissCare.</p>
                    </div>
                    <div className='flex flex-col items-center gap-6'>
                        <div className='flex flex-col lg:flex-row items-center gap-6'>
                            <InsuranceContent title='International Student Health Insurance Spain' />
                            <InsuranceContent title='International Student Health Insurance Europe' />
                            <InsuranceContent title='International Student Health Insurance Germany' />
                        </div>
                        <div className='flex flex-col lg:flex-row items-center gap-6'>
                            <InsuranceContent title='International Student Health Insurance Latvia' />
                            <InsuranceContent title='International Student Health Insurance Lithuania' />
                        </div>
                        <div className='flex flex-col lg:flex-row items-center gap-6'>
                            <InsuranceContent title='Schengen Visa Insurance' />
                            <InsuranceContent title='International Essential Medical Insurance' />
                        </div>
                    </div>
                    <Link to={"/health-travel-insurance"} className='p-3.5 bg-[#0B7F47] border-2 border-[#7FBC51] text-white text-sm flex items-center justify-center rounded-xl'>Buy Insurance</Link>
                </div>
            </section>

            <motion.section variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='max-w-7xl mx-auto py-20 px-9 space-y-10'>
                <motion.div variants={fadeUp} className='flex flex-col items-start gap-3'>
                    <img src="/images/flight_booking_tag.png" alt="Flight  Booking Section tag" />
                    <h2 className='text-[#030319] text-3xl font-bold font-display-fran'>Book a Flight with AfriPay</h2>
                    <p className='text-[#344054] text-xl'>Book flights to anywhere in the world with competitive prices and easy payment options. Your journey starts here.</p>
                </motion.div>
                <motion.div variants={fadeUp} className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <div className='shadow-md rounded-2xl'>
                        <img src="/images/lagos.avif" alt="Lagos Flight" className='w-full lg:w-120 rounded-2xl' />
                        <div className='p-6 space-y-4'>
                            <div className='w-full flex items-center justify-between'>
                                <div className='space-y-1'>
                                    <h4 className='text-[#101828] text-lg font-display-fran font-bold'>Lagos</h4>
                                    <p className='text-[#4A5565] text-sm'>Nigeria</p>
                                </div>
                                <div className='flex items-center gap-1 text-[#0A0A0A] text-sm'>
                                    <FaStar color='#FDC700' size={14} />
                                    <p>4.8</p>
                                </div>
                            </div>
                            <div className='flex items-center justify-between'>
                                <div>
                                    <h3 className='text-[#4A5565] text-xs '>Starting from</h3>
                                    <p className='text-xl text-[#0B7F47] font-bold'>₦45,000</p>
                                </div>
                                <Link to={'/bookflight'} className='py-1.5 px-3.5 flex items-center justify-center border-2 border-[#7FBC51] bg-[#0B7F47] text-white text-sm rounded-xl'>Book</Link>
                            </div>
                        </div>
                    </div>
                    <div className='shadow-md rounded-2xl'>
                        <img src="/images/dubai.avif" alt="Dubai Flight" className='w-full lg:w-120 rounded-2xl' />
                        <div className='p-6 space-y-4'>
                            <div className='w-full flex items-center justify-between'>
                                <div className='space-y-1'>
                                    <h4 className='text-[#101828] text-lg font-display-fran font-bold'>Dubai</h4>
                                    <p className='text-[#4A5565] text-sm'>UAE</p>
                                </div>
                                <div className='flex items-center gap-1 text-[#0A0A0A] text-sm'>
                                    <FaStar color='#FDC700' size={14} />
                                    <p>4.8</p>
                                </div>
                            </div>
                            <div className='flex items-center justify-between'>
                                <div>
                                    <h3 className='text-[#4A5565] text-xs '>Starting from</h3>
                                    <p className='text-xl text-[#0B7F47] font-bold'>₦180,000</p>
                                </div>
                                <Link to={'/bookflight'} className='py-1.5 px-3.5 flex items-center justify-center border-2 border-[#7FBC51] bg-[#0B7F47] text-white text-sm rounded-xl'>Book</Link>
                            </div>
                        </div>
                    </div>
                    <div className='shadow-md rounded-2xl'>
                        <img src="/images/paris.avif" alt="Paris Flight" className='w-full lg:w-120 rounded-2xl' />
                        <div className='p-6 space-y-4'>
                            <div className='w-full flex items-center justify-between'>
                                <div className='space-y-1'>
                                    <h4 className='text-[#101828] text-lg font-display-fran font-bold'>Paris</h4>
                                    <p className='text-[#4A5565] text-sm'>France</p>
                                </div>
                                <div className='flex items-center gap-1 text-[#0A0A0A] text-sm'>
                                    <FaStar color='#FDC700' size={14} />
                                    <p>4.8</p>
                                </div>
                            </div>
                            <div className='flex items-center justify-between'>
                                <div>
                                    <h3 className='text-[#4A5565] text-xs '>Starting from</h3>
                                    <p className='text-xl text-[#0B7F47] font-bold'>₦250,000</p>
                                </div>
                                <Link to={'/bookflight'} className='py-1.5 px-3.5 flex items-center justify-center border-2 border-[#7FBC51] bg-[#0B7F47] text-white text-sm rounded-xl'>Book</Link>
                            </div>
                        </div>
                    </div>
                    <div className='shadow-md rounded-2xl'>
                        <img src="/images/london.avif" alt="London Flight" className='w-full lg:w-120 rounded-2xl' />
                        <div className='p-6 space-y-4'>
                            <div className='w-full flex items-center justify-between'>
                                <div className='space-y-1'>
                                    <h4 className='text-[#101828] text-lg font-display-fran font-bold'>London</h4>
                                    <p className='text-[#4A5565] text-sm'>UK</p>
                                </div>
                                <div className='flex items-center gap-1 text-[#0A0A0A] text-sm'>
                                    <FaStar color='#FDC700' size={14} />
                                    <p>4.8</p>
                                </div>
                            </div>
                            <div className='flex items-center justify-between'>
                                <div>
                                    <h3 className='text-[#4A5565] text-xs '>Starting from</h3>
                                    <p className='text-xl text-[#0B7F47] font-bold'>₦220,000</p>
                                </div>
                                <Link to={'/bookflight'} className='py-1.5 px-3.5 flex items-center justify-center border-2 border-[#7FBC51] bg-[#0B7F47] text-white text-sm rounded-xl'>Book</Link>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </motion.section>

            {/* <div className='max-w-7xl mx-auto'>
                <img src="/images/simple_book_steps.avif" alt="Simlpe steps to Book" className="w-full mt-8 mb-16 hidden md:block" />
                <img src="/images/simple_book_steps_mobile.avif" alt="Simlpe steps to Book" className="w-full block md:hidden" />
            </div> */}

            {/* FAQ SECTION */}
            <section className="w-full px-4 pt-10 md:pt-20 pb-10">
                <div className="max-w-7xl mx-auto">
                    <div className="w-full flex flex-col md:flex-row items-start md:items-end justify-between mb-8 font-display-fran">
                        <div className="flex flex-col text-left gap-3 mb-4 md:mb-0">
                            <h2 className="text-2xl sm:text-2xl lg:text-4xl text-[#030319] font-display font-bold">
                                Everything You Need to Know
                            </h2>
                            <p className="text-[#344054] text-lg">Discover how AfriPay works and what makes us different</p>
                        </div>
                        <Link to={'/faq'} className="text-[#024529] flex items-center justify-center gap-1.5 cursor-pointer transition-all duration-300 hover:text-gray-600">
                            View All <FaRegArrowAltCircleRight />
                        </Link>
                    </div>
                    <div className="gap-8 lg:mt-16 mt-8 ">
                        <div className="lg:col-span-8 col-span-12">
                            <Accordion allowZeroExpanded allowMultipleExpanded>
                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>What is AfriPay?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay is an innovative platform simplifying
                                            international tuition payments, securing educational
                                            loans, and offering a digital wallet feature for
                                            seamless financial transactions.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>How does AfriPay simplify tuition payments?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay streamlines the tuition payment process, providing a user-friendly interface and multiple payment options for efficient and secure transactions.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>What security measures does AfriPay have in place?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay employs cutting-edge encryption technologies to ensure the security and confidentiality of user data, providing a safe environment for financial transactions.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>What is the digital wallet feature in AfriPay?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            The digital wallet feature allows users to conveniently manage and access funds, enabling cashless transactions, budgeting, and automated savings.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>How does AfriPay support educational loans?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay assists users in securing educational loans, streamlining the application process, and providing transparent terms for quick approvals.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                            </Accordion>

                        </div>
                    </div>
                    <div className="w-full flex justify-center pt-5">
                        <button type="button" onClick={openDownloadModal} className="w-[174px] h-13 rounded-lg bg-[#0B7F47] border-2 border-[#7FBC51] shadow-sm text-white text-sm p-3.5 cursor-pointer transition-colors duration-300 hover:bg-[#0B7F47]/60">Get started — it's free</button>
                    </div>
                </div>
            </section>

            <div className='max-w-7xl mx-auto mb-4 lg:mb-8'>
                <HeroCTA1 />
                <HeroCTA2 />
            </div>

            {/* Download AfriPay App */}
            <DownloadAfriPay />

            {/* <-- Footer --> */}
            <Footer />

        </>
    )
}

export default BillsPaymentV3

function InsuranceContent({ title }: { title: string }) {
    return (
        <Link to={'/health-travel-insurance'} className='w-[325.34px] h-[98px] flex items-center justify-center rounded-[40px] shadow-sm bg-[FFFFFF33] border border-[#0303191A] px-6 cursor-pointer transition-all duration-300 hover:bg-[#A7E762]'>
            <div className='w-full flex items-center gap-4'>
                <img src='/images/insurance_content.png' width={48} height={48} />
                <p className='w-[211px] text-[#030319] text-base leading-6'>{title === "Schengen Visa Insurance" ? (
                    <>
                        Schengen <br />
                        Visa Insurance
                    </>
                ) : (
                    title
                )}</p>
            </div>
        </Link >
    )
}